import React from 'react';
import BaseFilter from './base_filter';
import { FILTER_OPTIONS } from "./filter_constants_and_helpers";
import FilterSelect from '../partners/filter_select';
import { reject } from 'lodash';

const additionalFilterOptions = [
    // TODO - WORTHY-11118 - removed the 'Other' brand filter as the query it produces might crash the site - uncomment once the query is fixed
    // {id: -1, system_name: "jewelry_brand_other", pretty_name: "Other"},
    {id: -2, system_name: "jewelry_brand_not_branded", pretty_name: "Not Branded"}
];

class BrandDropdownFilter extends BaseFilter {

    constructor(props) {
        super(props)

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)

        // get visible options from all options.
        this.options = [...FILTER_OPTIONS.jewelry_brands, ...additionalFilterOptions]

        this._setFiltersInternal = this._setFiltersInternal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    removeFilter(name) {
        if ( name ) {
            this._setFiltersInternal(BrandDropdownFilter.getFilterName(), this._dropDownRemoveFilter(name, " brand"))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {in:[], not_in: [], is: []}
    }

    _setDefault() {
        this.setFilters(BrandDropdownFilter.getFilterName(),this._defaultValue())
    }

    _setFiltersInternal(filterName,newValue) {
        /*
        *  -1 - Other
        *  -2 - Not Branded
        * */
        const inFilterData = reject(newValue, e => e === -1 || e === -2);

        const newFilterData = {
            in: inFilterData,
            not_in: newValue.includes(-1) ? [-1] : [],
            is: newValue.includes(-2) ? [-2] : []
        };

        this.setFilters(filterName, newFilterData, this.removeFilter);
    }

    _render() {
        return <div><FilterSelect
            label={"Brand"}
            name={BrandDropdownFilter.getFilterName()}
            options={this.options}
            route={"recent_deals_"+this.props.itemType}
            selectedOptions={[...this.state.in, ...(this.state.not_in ? this.state.not_in : []), ...(this.state.is ? this.state.is : [])]}
            setFilters={this._setFiltersInternal}
            systemName={BrandDropdownFilter.getFilterName()}
        />
        </div>
    }

    _getFilterValue() {
        return {in:this.state.in, not_in: this.state.not_in, is: this.state.is}
    }

    _getFilterName() {
        return BrandDropdownFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of [ ...newState.in, ...(newState.not_in ? newState.not_in : []), ...(newState.is ? newState.is : []) ] ) {
            tagList.push(this.options.find(e => e.id == id).pretty_name + ' brand')
        }
        return tagList
    }

    _apiKeys() {
        return ["in", 'not_in', 'is']
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "jewelry_brands"
    }
}

export default BrandDropdownFilter;